import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { Button } from '@occc-app/design-system';
import { KioskAdScheduleInput } from '@occc/graphql';

import { ScheduleBlock, ScheduleBlockErrors } from './schedule-block';

const SECTION_TITLE = 'Schedule Ad Set';
const SECTION_SUBTITLE =
  'Set a time frame and select weekdays to define when your ads will be shown.';

type AdSetScheduleSectionProps = {
  schedules: KioskAdScheduleInput[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, value: KioskAdScheduleInput) => void;
  title?: string;
  subtitle?: string;
  errors?: ScheduleBlockErrors[];
};

export const AdSetScheduleSection = ({
  schedules,
  onAdd,
  onRemove,
  onChange,
  title = SECTION_TITLE,
  subtitle = SECTION_SUBTITLE,
  errors = [],
}: AdSetScheduleSectionProps) => {
  const hasMultipleSchedules = schedules.length > 1;

  return (
    <Box mb={2}>
      <Card>
        <CardHeader
          title={
            <Typography variant='subtitle1' paragraph>
              {title}
            </Typography>
          }
        />
        <CardContent>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
            {subtitle}
          </Typography>

          {schedules.length === 0 ? (
            <Button variant='outlined' color='primary' startIcon={<AddIcon />} onClick={onAdd}>
              ADD SCHEDULE BLOCK
            </Button>
          ) : (
            schedules.map((schedule, index) => (
              <ScheduleBlock
                isHeaderVisible={hasMultipleSchedules}
                isBorderVisible={hasMultipleSchedules}
                key={index}
                index={index}
                value={schedule}
                onChange={(value) => onChange(index, value)}
                onRemove={() => onRemove(index)}
                showAddButton={index === schedules.length - 1}
                onAdd={onAdd}
                canDelete={hasMultipleSchedules}
                errors={errors[index]}
              />
            ))
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
